import { render } from "./DataLokasi.vue?vue&type=template&id=e156b25e"
import script from "./DataLokasi.vue?vue&type=script&lang=js"
export * from "./DataLokasi.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__